
export const ContactFormPrivacyPolicy = () => {
  return (
    <div className="mt-8 text-center text-sm text-[#64748b]">
      <p>
        Al enviar este formulario, aceptas nuestra{" "}
        <a href="/privacidad" className="text-[#0284c7] hover:underline">
          Política de Privacidad
        </a>
      </p>
    </div>
  );
};
